export var manyGhostSelectionFiller = function manyGhostSelectionFiller(filterValue) {
  return {
    id: "many-ghost-selection-filler",
    type: "fill",
    source: "vineyards",
    "source-layer": "outnd",
    layout: {},
    paint: {
      "fill-opacity": 0
    }
    // Todo: Wait and see buffer usages
    // filter: [
    //   "in",
    //   this.cadastreAddress.toLowerCase(),
    //   ["downcase", ["get", "nomcom"]],
    // ],
  };
};
export var manySelectionFiller = function manySelectionFiller(hasOpacity, filterValue) {
  return {
    id: "many-selection-filler",
    type: "fill",
    source: "vineyards",
    "source-layer": "outnd",
    layout: {},
    paint: {
      "fill-color": "#dbdbda",
      "fill-opacity": hasOpacity ? 0.05 : 0
    },
    filter: ["==", filterValue !== null && filterValue !== void 0 ? filterValue : null, ["get", "nomcom"], ["collator", {
      caseSensitive: false,
      diacriticSensitive: false
    }]]
  };
};
export var singleCadastreSelectionFiller = function singleCadastreSelectionFiller(filterValue) {
  return {
    id: "single-cadastre-selection-filler",
    type: "fill",
    source: "vineyards",
    "source-layer": "outnd",
    layout: {},
    paint: {
      "fill-color": "#dbdbda",
      "fill-opacity": 0.25
    },
    filter: ["==", filterValue, ["get", "denom"], ["collator", {
      caseSensitive: false,
      diacriticSensitive: false
    }]]
  };
};
export var singleCadastreSelectionBorder = function singleCadastreSelectionBorder(filterValue) {
  return {
    id: "single-cadastre-selection-border",
    type: "line",
    source: "vineyards",
    "source-layer": "outnd",
    filter: ["==", filterValue, ["get", "denom"], ["collator", {
      caseSensitive: false,
      diacriticSensitive: false
    }]],
    layout: {},
    paint: {
      "line-color": "#fdd068",
      "line-dasharray": ["step", ["zoom"], ["literal", [4, 0]], 5, ["literal", [4, 2]], 10, ["literal", [4, 2]], 15, ["literal", [4, 3]]],
      "line-width": ["interpolate", ["linear"], ["zoom"], 10, 1, 15, 4, 17, 8],
      "line-opacity": ["interpolate", ["linear"], ["zoom"], 15, 1, 16, 1]
    }
  };
};
export var VineyardsGUID = function VineyardsGUID(filterValue) {
  return {
    id: "vineyards-guid",
    type: "fill",
    source: "vineyards-guid",
    "source-layer": "wineries-guid-3s50u6",
    layout: {},
    paint: {
      "fill-color": "#b47c3c",
      "fill-opacity": 0.25
    }
  };
};
export var singleCadastreSelectionBorderGUID = function singleCadastreSelectionBorderGUID(filterValue) {
  return {
    id: "single-cadastre-selection-border-guid",
    type: "line",
    source: "vineyards-guid",
    "source-layer": "wineries-guid-3s50u6",
    filter: ["==", filterValue, ["get", "guid"], ["collator", {
      caseSensitive: false,
      diacriticSensitive: false
    }]],
    paint: {
      "line-color": "#fdd068",
      "line-dasharray": ["step", ["zoom"], ["literal", [4, 0]], 5, ["literal", [4, 2]], 10, ["literal", [4, 2]], 15, ["literal", [4, 3]]],
      "line-width": ["interpolate", ["linear"], ["zoom"], 10, 1, 15, 4, 17, 8],
      "line-opacity": ["interpolate", ["linear"], ["zoom"], 15, 1, 16, 1]
    }
  };
};
export var manySelectionFillerGUID = function manySelectionFillerGUID(hasOpacity, filterValue) {
  return {
    id: "many-selection-filler",
    type: "fill",
    source: "vineyards-guid",
    "source-layer": "wineries-guid-3s50u6",
    layout: {},
    paint: {
      "fill-color": "#000",
      "fill-opacity": hasOpacity ? 0.05 : 0
    },
    filter: ["==", filterValue !== null && filterValue !== void 0 ? filterValue : null, ["get", "guid"], ["collator", {
      caseSensitive: false,
      diacriticSensitive: false
    }]]
  };
};